import { Stack, Typography } from '@mui/material'
import { CheckCircleOutline, Reply } from '@workwave-tidal/core/icons'

import { preview } from '@/components/form/preview'

import { FieldPointsContainer } from './FieldPointsContainer'

import { useTexts } from '../../hooks/useTexts'

interface Props {
  companyEmail: string
  showContactEmail: boolean
  useCompanyEmailAsReplyTo: boolean
}

export function CompanyEmail(props: Props) {
  const { companyEmail, showContactEmail, useCompanyEmailAsReplyTo } = props

  const texts = useTexts()

  return (
    <preview.Field testId="trackingPage-companyEmail" label={texts.companyEmail}>
      <preview.Value variant="alternative">{companyEmail}</preview.Value>

      {showContactEmail || useCompanyEmailAsReplyTo ? (
        <FieldPointsContainer>
          {showContactEmail && (
            <Stack direction="row" alignItems="center" spacing={0.5}>
              <CheckCircleOutline sx={{ fontSize: '16px', flexShrink: 0 }} color="primary" />
              <Typography variant="caption" lineHeight={1}>
                {texts.showContactEmail}
              </Typography>
            </Stack>
          )}
          {useCompanyEmailAsReplyTo && (
            <Stack direction="row" alignItems="center" spacing={0.5}>
              <Reply sx={{ fontSize: '16px', flexShrink: 0 }} color="primary" />
              <Typography variant="caption" lineHeight={1}>
                {texts.usedCompanyEmailAsReplyTo}
              </Typography>
            </Stack>
          )}
        </FieldPointsContainer>
      ) : null}
    </preview.Field>
  )
}
